import type { PromoProductModel } from '@/shared/generated'
import type { TFunction } from 'i18next'

import NumberField from '@/shared/components/data-grid/fields/Number/TableCell'
import { createSRTColumnHelper } from '@/shared/components/master-table'

const columnHelper = createSRTColumnHelper<PromoProductModel>()
export function getColumn(t: TFunction) {
	return [
		columnHelper.accessor('sku', {
			size: 120,
			header: t('sku', { defaultValue: 'SKU' }),
			Cell: ({ cellValue }) => cellValue,
		}),
		columnHelper.accessor('title', {
			size: 120,
			header: t('products_title', { defaultValue: 'Title' }),
			Cell: ({ cellValue }) => <span>{cellValue}</span>,
		}),
		columnHelper.accessor('discount_percent', {
			size: 120,
			header: t('discount_percent', { defaultValue: 'Discount percent' }),
			Cell: ({ cellValue }) => <NumberField value={cellValue} />,
		}),
		columnHelper.accessor('discount_sum', {
			size: 120,
			header: t('discount_sum', { defaultValue: 'Discount sum' }),
			Cell: ({ cellValue }) => <NumberField value={cellValue} />,
		}),
		columnHelper.accessor('discount_price', {
			size: 120,
			header: t('discount_price', { defaultValue: 'Discount price' }),
			Cell: ({ cellValue }) => <NumberField value={cellValue} />,
		}),
		columnHelper.accessor('predicted_growth_rate', {
			size: 120,
			header: t('predicted_growth_rate', {
				defaultValue: 'Predicted growth rate',
			}),
			Cell: ({ cellValue }) => <NumberField value={cellValue} />,
		}),
	]
}
